<template>
  <div class="content" @scroll="scrollEven">
    <div class="banner">
      <img
        src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/about-banner.png"
      />
      <div class="banner-text">
        <h3 class="banner-h" id="bannerH">{{ $t("aboutUstab") }}</h3>
        <label>{{ $t("aboutus.titleSecondaryTitle") }}</label>
      </div>
    </div>
    <div class="about">
      <div class="honour">
        <div class="honour-bg fadeIn">OUR HONOR</div>
        <h3 class="fadeIn">{{ $t("aboutus.content1title") }}</h3>
        <span class="fadeIn">{{ $t("aboutus.content1SecondaryTitle") }}</span>
        <p class="fadeIn">{{ $t("aboutus.content1SecondaryTitle2") }}</p>
        <div class="swiper-full">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in bannerList"
                :key="index"
              >
                <img class="honour-img" :src="item" />
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <!-- <div class="swiper-pagination"></div> -->
          </div>
          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev" slot="button-prev">
            <img :src="rightWhite" />
          </div>
          <div class="swiper-button-next" slot="button-next">
            <img :src="leftWhite" />
          </div>
        </div>
      </div>

      <!-- <div class="about-content1">
        <div class="content1-left">
          <h1 class="fadeIn">Ship Chandlery Services</h1>
          <div class="bottom-header fadeIn">
            <div class="point"></div>
            <label>PROVISION, BONDED AND GENERAL SUPPLIES</label>
          </div>
          <p class="fadeIn">
            Provisions & bonded products: We offer contracted prices for up to
            12 months on 1900 items in China, Panama, and Singapore. We purchase
            fresh provisions locally and deliver these in temperature controlled
            bins. All meats & fish are hard frozen, fresh products blemish free,
            canned food items free of rust and dents. All our supplies have
            clear expiry dates and are labelled in English.
          </p>
          <p>
            General deck & engine supplies: We offer contracted prices for up to
            12 months on 4600 deck and engine supplies for delivery in China,
            Panama, and Singapore. With time and experience, we have built an
            inventory of high-quality products. However, we can also source
            specific brands on request as well. All products from our general
            stores come with a 12 month guarantee after delivery on board.
          </p>
        </div>
        <div class="content1-right">
          <img
            src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/about-p1.png"
            class="surname1 fromTop"
          />
        </div>
      </div> -->
      <!-- <div class="about-content2">
        <div class="about-content2-backG surname3">
          <div class="card">
            <h1 class="Amove1">Initial Supplies</h1>
            <div class="bottom-header Amove2">
              <div class="point"></div>
              <label>NEW VESSELS</label>
            </div>
            <p class="Amove3">
              We can support you during your building projects in ship yards. We
              know that a new vessel delivery is always special and as
              owners/managers, you want the best quality products on board at
              this time. At EMSOL, we have a dedicated team focusing on initial
              supplies and logistics – from Europe to ship yards around Asia. We
              can also assist you to process claims under your ship yard
              guarantees.
            </p>
          </div>
        </div>
      </div> -->
      <!-- <div class="about-content1">
        <div class="content1-right1">
          <img
            src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/about-p3.png"
            class="surname5"
          />
        </div>

        <div class="content1-left">
          <h1 class="Amove4">Repair, Maintenance and Fabrication Services</h1>
          <div class="bottom-header Amove5">
            <div class="point"></div>
            <label>PARTNER NETWORK</label>
          </div>
          <p class="Amove6">
            Our global partner network – certified across different
            classifications – can support you during crises. We also step in to
            manage financial logistics such as payment to local workshops during
            crunch time.
          </p>
          <p class="Amove7">
            During an emergency, our partner network will ensure that you are
            not taken advantage of.
          </p>
        </div>
      </div> -->
    </div>
    <div class="full-content3">
      <div class="about-content3">
        <div class="content3-left">
          <h1 class="Amove8">{{ $t("aboutus.content3title") }}</h1>
          <div class="bottom-header Amove9">
            <div class="point"></div>
            <label>{{ $t("aboutus.content3SecondaryTitle") }}</label>
          </div>
          <p class="Amove10">
            {{ $t("aboutus.content3P1") }}
          </p>
        </div>
        <div class="content3-rightCopy">
          <div
            :class="defaultActive == 0 ? 'card-big' : ''"
            :style="'background-image:url(' + people1 + ')'"
            class="card1 card"
            @mouseover="mouseover(0)"
          >
            <div class="mont"></div>
            <div class="info">
              <div class="real-info">
                <h1>Mrs. Sharon Lu</h1>
                <label>General Manager – NanTong</label>
                <p>Ship supplier with 10 + years experience in the industry</p>
              </div>
            </div>
          </div>
          <div
            :class="defaultActive == 1 ? 'card-big' : ''"
            :style="'background-image:url(' + people2 + ')'"
            class="card"
            @mouseover="mouseover(1)"
          >
            <div class="mont"></div>
            <div class="info">
              <div class="real-info">
                <h1>M.J. Fan</h1>
                <label>General Manager – ZhouShan</label>
                <p>
                  Serviced in COSCO shipyard as production manager for 4 years ;
                  Serviced in Zhejiang Youlian (EX.ZESCO) as business manager
                  for 7 years;
                </p>
              </div>
            </div>
          </div>
          <div
            :class="defaultActive == 2 ? 'card-big' : ''"
            class="card"
            @mouseover="mouseover(2)"
            :style="'background-image:url(' + people3 + ')'"
          >
            <div class="mont"></div>
            <div class="info">
              <div class="real-info">
                <h1>Kent Fong</h1>
                <label>General Manager – SINGAPORE</label>
                <p>Ship supplier with 13 years experience in the industry.</p>
              </div>
            </div>
          </div>
          <div
            :class="defaultActive == 3 ? 'card-big' : ''"
            :style="'background-image:url(' + people4 + ')'"
            class="card card3"
            @mouseover="mouseover(3)"
          >
            <div class="mont"></div>
            <div class="info">
              <div class="real-info">
                <h1>Mrs. Alina Soutsiou</h1>
                <label>Greece Representative</label>
                <p>
                  Ship supply Specialist with 5 years experience in the industry
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="app-footer">
      © 2022 Emsol Maine Service Pte Ltd. All Right Reserved.
    </footer>
  </div>
</template>

<script >
import aboutBanner from "../assets/img/about-banner.png";
import aboutP1 from "../assets/img/about-p1.png";
import aboutP3 from "../assets/img/about-p3.png";
import people1 from "../assets/img/people1.png";
import people2 from "../assets/img/people2.jpg";
import people3 from "../assets/img/people3.jpg";
import people4 from "../assets/img/people4.jpg";
import leftWhite from "../assets/img/leftWhite.png";
import rightWhite from "../assets/img/rightWhite.png";
import "swiper/dist/js/swiper";
import "swiper/dist/css/swiper.css";
import Swiper from "swiper";

export default {
  name: "app-about",

  data() {
    return {
      aboutBanner,
      aboutP1,
      aboutP3,
      people1,
      people2,
      people3,
      people4,
      leftWhite,
      rightWhite,
      defaultActive: 0,
      swiperOption: {},
      bannerList: [
        "http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/p1.png?x-oss-process=image/sharpen,100",
        "http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/p2.png?x-oss-process=image/sharpen,100",
        "http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/p3.png?x-oss-process=image/sharpen,100",
        "http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/p4.png?x-oss-process=image/sharpen,100",
        "http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/p5.png?x-oss-process=image/sharpen,100",
        "http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/p6.png?x-oss-process=image/sharpen,100",
        "http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/p7.png?x-oss-process=image/sharpen,100",
        "http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/p8.png?x-oss-process=image/sharpen,100",
      ],
    };
  },
  mounted() {
    let slidesPerView = 4.287;
    let stretch = 103.4;
    let depth = 92.6;
    let winWidth = window.innerWidth;
    if (winWidth < 1500) {
      stretch = 66.5;
      depth = 106;
    }
    new Swiper(".swiper-container", {
      autoplay: {
        //自动开始
        delay: 2500, //时间间隔
        disableOnInteraction: false, //*手动操作轮播图后不会暂停*
      },
      slideToClickedSlide: true,
      loop: true, // 循环模式选项
      effect: "coverflow",
      slidesPerView, // 设置slider容器能够同时显示的slides数量(carousel模式)
      centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左。
      initialSlide: 3,
      coverflowEffect: {
        rotate: 15,
        stretch, // 指的时后面一张图片被前一张图片遮挡的部分
        depth, // 图片缩小的部分
        modifier: 1,
        slideShadows: false,
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true, // 分页器可以点击
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  },
  methods: {
    mouseover(e) {
      this.defaultActive = e;
    },
    scrollEven(e) {
      let { scrollTop } = e.target;
      let realHeight =
        document.getElementsByClassName("content")[0].clientHeight +
        scrollTop +
        20;
      // let content2 = document.getElementsByClassName("about-content2-backG")[0];
      // let Amove1 = document.getElementsByClassName("Amove1")[0];
      // let Amove2 = document.getElementsByClassName("Amove2")[0];
      // let surname3 = document.getElementsByClassName("surname3")[0];
      // let Amove3 = document.getElementsByClassName("Amove3")[0];
      // let Amove4 = document.getElementsByClassName("Amove4")[0];
      // let Amove5 = document.getElementsByClassName("Amove5")[0];
      // let Amove6 = document.getElementsByClassName("Amove6")[0];
      // let Amove7 = document.getElementsByClassName("Amove7")[0];
      let Amove8 = document.getElementsByClassName("Amove8")[0];
      let Amove9 = document.getElementsByClassName("Amove9")[0];
      let Amove10 = document.getElementsByClassName("Amove10")[0];
      // if (
      //   realHeight > content2.offsetTop &&
      //   realHeight < content2.offsetTop + 60
      // ) {
      //   surname3.classList.add("fromTop");
      // } else if (
      //   realHeight > content2.offsetTop + 150 &&
      //   realHeight < content2.offsetTop + 180
      // ) {
      //   Amove1.classList.add("fadeIn");
      //   Amove2.classList.add("fadeIn");
      // } else if (
      //   realHeight > content2.offsetTop + 180 &&
      //   realHeight < content2.offsetTop + 300
      // ) {
      //   Amove3.classList.add("fadeIn");
      // } else if (
      //   realHeight > Amove4.offsetTop &&
      //   realHeight < Amove5.offsetTop
      // ) {
      //   Amove4.classList.add("fadeIn");
      //   document.getElementsByClassName("surname5")[0].classList.add("fromTop");
      // } else if (
      //   realHeight > Amove5.offsetTop &&
      //   realHeight < Amove6.offsetTop
      // ) {
      //   Amove5.classList.add("fadeIn");
      // } else if (
      //   realHeight > Amove6.offsetTop &&
      //   realHeight < Amove7.offsetTop
      // ) {
      //   Amove6.classList.add("fadeIn");
      // } else if (
      //   realHeight > Amove7.offsetTop &&
      //   realHeight < Amove8.offsetTop
      // ) {
      //   Amove7.classList.add("fadeIn");
      // } else
      if (realHeight > Amove8.offsetTop) {
        Amove8.classList.add("fadeIn");
      }
      if (realHeight > Amove9.offsetTop) {
        Amove9.classList.add("fadeIn");
      }
      if (realHeight > Amove10.offsetTop) {
        Amove10.classList.add("fadeIn");
      }
    },
  },
};
</script>


<style scoped lang="less">
.content {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);
  margin-top: 80px;
  overflow-y: scroll;
  overflow-x: hidden;
  a {
    text-decoration: none;
  }
  .banner {
    width: 100%;
    height: 420px;
    position: relative;
    margin-bottom: 120px;
    img {
      width: 100%;
      height: 100%;
    }
    .banner-text {
      position: absolute;
      top: 127px;
      left: 240px;
      text-align: left;
      .banner-h {
        margin: 20px 0;
        font-size: 54px;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #ffffff;
        line-height: 41px;
      }
      #bannerH {
        -webkit-animation: bannerH1 0.6s 0.2s ease both;
        -moz-animation: bannerH1 0.6s 0.2s ease both;
      }
      @-webkit-keyframes bannerH1 {
        0% {
          opacity: 0;
          -webkit-transform: translateX(200px);
        }
        100% {
          opacity: 1;
          -webkit-transform: translateX(0);
        }
      }
      @-moz-keyframes bannerH1 {
        0% {
          opacity: 0;
          -moz-transform: translateX(200px);
        }
        100% {
          opacity: 1;
          -moz-transform: translateX(0);
        }
      }
      label {
        font-size: 20px;
        font-family: Arial-Regular, Arial;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
      }
    }
  }
  .about {
    // width: 1440px;
    margin: 0 auto;
    .honour {
      display: flex;
      flex-direction: column;
      position: relative;
      align-items: center;
      margin-bottom: 120px;
      .honour-bg {
        position: absolute;
        top: -24px;
        font-size: 58px;
        width: 561px;
        height: 65px;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #f6f6f7;
        line-height: 0px;
      }
      h3 {
        position: relative;
        z-index: 2;
        font-size: 40px;
        font-family: Microsoft YaHei UI-Bold, Microsoft YaHei UI;
        font-weight: bold;
        color: #2a2e2e;
        line-height: 0px;
        margin-top: 0;
        margin-bottom: 36px;
      }
      span,
      p {
        font-size: 16px;
        font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI;
        font-weight: 400;
        color: #2a2e2e;
        line-height: 30px;
      }
      p {
        margin-bottom: 80px;
        margin-top: 0;
      }
    }
  }
  // .about-content1 {
  //   padding: 120px 0 130px 0;
  //   display: flex;
  //   justify-content: space-between;
  //   .content1-right,
  //   .content1-right1 {
  //     position: relative;
  //     width: 658px;
  //     height: 535px;
  //     .surname1 {
  //       width: 100%;
  //       height: 100%;
  //       position: absolute;
  //       z-index: 1;
  //       top: 0;
  //       left: 0;
  //       transform: scaleX(0);
  //       border-radius: 10px;
  //       background-color: rgba(241, 243, 246, 0.7);
  //     }
  //     .surname2 {
  //       width: 100%;
  //       height: 100%;
  //       position: absolute;
  //       z-index: 2;
  //       top: 0;
  //       left: 0;
  //       transform: scaleX(0);
  //       border-radius: 10px;
  //       background-color: rgba(241, 243, 246, 1);
  //     }
  //     .surname5 {
  //       width: 100%;
  //       height: 100%;
  //       position: absolute;
  //       z-index: 1;
  //       top: 0;
  //       left: 0;
  //       transform: scaleX(0);
  //       border-radius: 10px;
  //       background-color: rgba(241, 243, 246, 0.7);
  //     }
  //     .surname6 {
  //       width: 100%;
  //       height: 100%;
  //       position: absolute;
  //       z-index: 2;
  //       top: 0;
  //       left: 0;
  //       transform: scaleX(0);
  //       border-radius: 10px;
  //       background-color: rgba(241, 243, 246, 1);
  //     }
  //     img {
  //       width: 100%;
  //       height: 100%;
  //     }
  //   }
  //   .content1-left {
  //     display: flex;
  //     flex-direction: column;
  //     text-align: left;
  //     width: 48%;
  //     .Amove4 {
  //       opacity: 0;
  //     }
  //     .Amove5 {
  //       opacity: 0;
  //     }
  //     .Amove6 {
  //       opacity: 0;
  //     }
  //     .Amove7 {
  //       opacity: 0;
  //     }
  //     h1 {
  //       font-size: 40px;
  //       font-family: Arial-Bold, Arial;
  //       font-weight: bold;
  //       color: #2a2e2e;
  //       margin-bottom: 20px;
  //       margin-top: 30px;
  //     }
  //     p {
  //       font-size: 16px;
  //       font-family: Arial-Regular, Arial;
  //       font-weight: 400;
  //       color: #2a2e2e;
  //       line-height: 30px;
  //     }
  //     .bottom-header {
  //       display: flex;
  //       align-items: center;
  //       font-size: 16px;
  //       font-family: Arial-Regular, Arial;
  //       font-weight: 400;
  //       padding-bottom: 40px;
  //       color: #2a358e;
  //       border-bottom: 1px solid #dee0e3;
  //     }
  //   }
  // }
  // .about-content2 {
  //   height: 719px;
  //   width: 100%;
  //   box-sizing: border-box;
  //   .about-content2-backG {
  //     position: relative;
  //     width: 100%;
  //     height: 719px;
  //     background-size: cover;
  //     background-repeat: no-repeat;
  //     background-image: url("http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/about-p2.png");
  //     .surname3 {
  //       width: 100%;
  //       height: 100%;
  //       position: absolute;
  //       z-index: 1;
  //       top: 0;
  //       left: 0;
  //       transform: scaleX(0);
  //       border-radius: 10px;
  //       background-color: rgba(241, 243, 246, 0.7);
  //     }
  //     .surname4 {
  //       width: 100%;
  //       height: 100%;
  //       position: absolute;
  //       z-index: 2;
  //       top: 0;
  //       left: 0;
  //       transform: scaleX(0);
  //       border-radius: 10px;
  //       background-color: rgba(241, 243, 246, 1);
  //     }
  //     .card {
  //       position: absolute;
  //       text-align: left;
  //       padding: 57px 38px 103px 60px;
  //       right: -38px;
  //       z-index: 3;
  //       top: 133.5px;
  //       width: 690px;
  //       height: 322px;
  //       background: rgba(248, 249, 250, 0.97);
  //       border-radius: 20px 20px 20px 20px;
  //       h1 {
  //         font-size: 40px;
  //         opacity: 0;
  //         font-family: Arial-Bold, Arial;
  //         font-weight: bold;
  //         color: #2a2e2e;
  //         margin-bottom: 20px;
  //         margin-top: 30px;
  //       }
  //       .bottom-header {
  //         display: flex;
  //         opacity: 0;
  //         align-items: center;
  //         font-size: 16px;
  //         font-family: Arial-Regular, Arial;
  //         font-weight: 400;
  //         padding-bottom: 30px;
  //         color: #2a358e;
  //         border-bottom: 1px solid #dee0e3;
  //       }
  //       p {
  //         margin-top: 36px;
  //         opacity: 0;
  //         margin-bottom: 0;
  //         line-height: 30px;
  //         font-size: 16px;
  //         font-family: Arial-Regular, Arial;
  //         font-weight: 400;
  //         color: #2a2e2e;
  //       }
  //     }
  //   }
  // }
  .swiper-full {
    width: 1540px;
    padding-left: 50px;
    padding-right: 50px;
    .swiper-button-prev,
    .swiper-button-next {
      height: 0;
      top: 60%;
    }
    .swiper-button-prev {
      left: -10px;
    }
    .swiper-container {
      width: 1440px;
      // height: 500px;
      .swiper-wrapper {
        width: 1440px;
      }
      .swiper-slide {
        width: 336.25px !important;
        height: 461.88px;
      }
      .honour-img {
        width: 336.25px;
        height: 461.88px;
      }
      .swiper-pagination {
        bottom: 0;
      }
    }
  }

  .full-content3 {
    background-color: #f8f9fa;
    width: 100vw;
    padding-top: 120px;
    .about-content3 {
      width: 1440px;
      margin: 0 auto;
      padding-bottom: 120px;
      display: flex;
      justify-content: space-between;
      .content3-left {
        display: flex;
        flex-direction: column;
        text-align: left;
        width: 25%;
        .Amove8 {
          opacity: 0;
        }
        .Amove9 {
          opacity: 0;
        }
        .Amove10 {
          opacity: 0;
        }
        h1 {
          font-size: 40px;
          font-family: Arial-Bold, Arial;
          font-weight: bold;
          color: #2a2e2e;
          margin-bottom: 20px;
          margin-top: 30px;
        }
        p {
          font-size: 16px;
          font-family: Arial-Regular, Arial;
          font-weight: 400;
          color: #2a2e2e;
          line-height: 30px;
        }
        .bottom-header {
          display: flex;
          align-items: center;
          font-size: 16px;
          font-family: Arial-Regular, Arial;
          font-weight: 400;
          padding-bottom: 40px;
          color: #2a358e;
          border-bottom: 1px solid #dee0e3;
        }
      }
      .content3-rightCopy {
        display: flex;
        .card1 {
          float: left;
        }
        .card3 {
          float: right;
        }
        .card {
          width: 200px;
          height: 460px;
          margin-right: 20px;
          position: relative;
          box-sizing: border-box;
          padding: 228px 12px 32px;
          border-radius: 10px;
          background-size: cover;
          background-repeat: no-repeat;
          overflow: hidden;
          color: #fff;
          transition: all 0.2s ease-in-out;
          background-position: 50%;
          img {
            width: 345px;
            height: 100%;
          }
          .mont {
            position: absolute;
            top: 0;
            left: 0;
            background-size: contain;
            background-repeat: no-repeat;
            width: 100%;
            height: 100%;
            // background-image: linear-gradient(
            //   180deg,
            //   rgba(24, 24, 24, 0),
            //   rgba(24, 24, 24, 0.99)
            // );
            transition: all 0.3s ease-in-out;
            background-color: rgba(0, 0, 0, 0.4);
          }
          .info {
            position: absolute;
            z-index: 3;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            padding-top: 183px;
            transform: translateY(460px);
          }
        }

        .card-big {
          width: 345px;
          .mont {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 1;
            background-color: rgba(0, 0, 0, 0);
          }
          .info {
            transform: translateY(0px);
            transition: all 0.5s ease-in-out;
            transition-delay: 0.1s;
            .real-info {
              height: 287px;
              box-sizing: border-box;
              padding: 36px 20px;
              display: flex;
              flex-direction: column;
              align-items: center;
              border-radius: 10px 10px 10px 10px;
              background-color: rgba(42, 53, 142, 0.9);
            }
            h1 {
              font-size: 30px;
              font-family: Arial-Regular, Arial;
              font-weight: 400;
              color: #ffffff;
              margin-top: 4px;
              margin-bottom: 10px;
            }
            label {
              font-size: 16px;
              font-family: Arial-Regular, Arial;
              font-weight: 400;
              color: #ffffff;
            }
            p {
              margin-top: 32px;
              margin-bottom: 0;
              height: 119px;
              font-size: 16px;
              font-family: Arial-Regular, Arial;
              font-weight: 400;
              color: #ffffff;
              line-height: 24px;
            }
          }
        }
      }
    }
  }
}
.point {
  width: 10px;
  height: 10px;
  margin-right: 12px;
  background: #2a358e;
  border-radius: 50%;
}
</style>